module.exports = __webpack_public_path__ + "081b11ebaca8ad30fd092e01451015dc.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.woff
// module id = 343
// module chunks = 0